import React from 'react';

import {
	Icon,
	styled
} from 'ps-gui';
import { formatFileSize } from '../modules/utils';

const Wrapper = styled.div`
	position: relative;
	background: #FFFFFF;
	> .pane {
		padding: 8px;
		max-height: ${props => props.maxHeight};
		overflow-y: auto;
		overflow-x: hidden;
	}
	box-shadow: 7px 13px 80px rgba(21, 46, 67, 0.1);
	border-radius: 15px;
	padding: 8px;
	margin-bottom: 24px;
	table {
		border-collapse: collapse;
		width: 100%;
		tr {
			&:hover {
				background: ${props => props.theme.tableRowHoverBackground};
			}
			color: #575757;
			&.deleted {
				opacity: 0.4;
				.name, .size {
					text-decoration: line-through;
				}
			}
			&.added {
				color: #297FCA;
			}
		}
		td {
			padding: 8px 12px;
		}
		.name {
			font-weight: 500;
			font-size: 16px;
			width: 80%;
		}
		.size {
			font-size: 14px;
			font-weight: 300;
			color: #575757;
			text-align: right;
			width: 20%;
			white-space: nowrap;
		}
		.downloadFile {
			width: 1px;
		}
		.deleteFile {
			width: 1px;
		}
	}
`;

export default class FileList extends React.PureComponent {
	render() {
		const files = this.props.files;
		if (!files || files.size === 0) {
			return null;
		}
		return (
			<Wrapper maxHeight={this.props.maxHeight}>
				<div className="pane">
					<table>
						<tbody>
							{
								files.map((file, index) => {
									const deleted = file.get('_deleted');
									return (
										<tr key={index} className={(deleted ? 'deleted' : '') + (file.get('_added') ? ' added' : '')}>
											<td className="name">{file.get('fileName')}</td>
											<td className="size">{formatFileSize(file.get('size'))}</td>
											{
												this.props.onDownloadRequested && 
												<td className="download">
													{
														!deleted && 
															<Icon
																name="downloadFile"
																active
																onMouseDown={() => {
																	this.props.onDownloadRequested(file, index);
																	//this.downloadFile(file);
																}}
															/>
														
													}
												</td>
											
											}
											{
												this.props.onDeleteRequested && 
												<td className="delete">
													<Icon
														name="deleteFile"
														active
														onMouseDown={() => {
															this.props.onDeleteRequested(file, index);
														}}
													/>
												</td>
											
											}
										</tr>
									);
								})
							}
						</tbody>
					</table>
				</div>
			</Wrapper>
		);
	}
}
